import type { ReactNode } from 'react'

import * as styles from './content-navigation-styles'

type Props = {
  children: ReactNode
}

export const ContentNavigation = ({ children }: Props) => (
  <nav aria-label="Navigation of contents" css={styles.nav}>
    {children}
  </nav>
)
